import React from 'react';
import { observer } from 'mobx-react';
import { PersonalInfoForm } from '../../forms/application-information-forms';
import { Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import * as Styles from './citizenship-information.less';

interface ICitizenshipInformationProps {
    personalInfo: PersonalInfoForm;
}

export const CitizenshipInformation: React.FC<ICitizenshipInformationProps> = observer(
    ({ personalInfo }) => {
        return (
            <>
                <div className={Styles.sectionTitle}>Are you a US Citizen? *</div>
                <div className={Styles.row}>
                    <div className={Styles.shortCol}>
                        <RadioGroup
                            row
                            value={personalInfo.$.IsUSCitizen.value.toString()}
                            onChange={(e, val) =>
                                personalInfo.$.IsUSCitizen.onChange(JSON.parse(val))
                            }
                        >
                            <FormControlLabel
                                className={Styles.radioLabel}
                                value="true"
                                control={<Radio className={Styles.radio} />}
                                label="Yes"
                            />
                            <FormControlLabel
                                className={Styles.radioLabel}
                                value="false"
                                control={<Radio className={Styles.radio} />}
                                label="No"
                            />
                        </RadioGroup>
                    </div>
                </div>
            </>
        );
    }
);
